module.exports = __webpack_public_path__ + "static/media/teaser2-coppenrath-wiese-x2.2082db56.jpg";